import axios from "axios";
import { backend } from "../config/environment";

const client = axios.create({
  baseURL: backend.AUTH_URI,
  timeout: 100000,
  withCredentials: true,
});

export default client;
